import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ForecastGridService } from "../../services/forecastGridService";
(function (module) {
    "use strict";

    module.component('forecastChangeProductCode', {
        template: require('./forecastChangeProductCodeComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: ['$scope', angularServicesNames.$translate, ForecastGridService.componentName, 'forecastProcessService', AgGridService.componentName,
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                forecastGridService: ForecastGridService,
                forecastProcessService: $TSFixMe,
                agGridService: AgGridService
            ) {
                var $ctrl = this;

                $ctrl.forecastProductCodesGrid = {
                    columnDefs: [
                        {
                            headerCheckboxSelection: true,
                            headerCheckboxSelectionFilteredOnly: true,
                            checkboxSelection: true,
                            field: "forecastName", cellRenderer: 'agGroupCellRenderer',
                            minWidth: 245,
                            headerValueGetter: () => $translate.instant("FORECAST.CHANGE_PRODUCT_CODE.GRID.FORECAST_NAME"),
                            filter: "agSetColumnFilter", filterParams: { newRowsAction: 'keep' }
                        },
                        {
                            field: "forecastStatus", headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.STATUS"),
                            filter: 'agSetColumnFilter',
                            cellRenderer: (params: $TSFixMe) => params.value ? $translate.instant(params.value) : '',
                            filterParams: {
                                values: ['Draft', 'AwaitingBUMApproval', 'ReturnedToCorrection', 'Approved'], newRowsAction: 'keep',
                                cellRenderer: (params: $TSFixMe) => params.value ? $translate.instant(params.value) : ''
                            }
                        },
                        {
                            field: "forecastStartYear", cellRenderer: 'agGroupCellRenderer',
                            headerValueGetter: () => $translate.instant("FORECAST.CHANGE_PRODUCT_CODE.GRID.START_YEAR"),
                            filter: "agSetColumnFilter", filterParams: { newRowsAction: 'keep' }
                        },
                        { field: "oldProductCode", headerValueGetter: () => $translate.instant("FORECAST.CHANGE_PRODUCT_CODE.GRID.OLD_PRODUCT_CODE") },
                        { field: "newProductCode", headerValueGetter: () => $translate.instant("FORECAST.CHANGE_PRODUCT_CODE.GRID.NEW_PRODUCT_CODE") },
                    ],
                    angularCompileRows: true,
                    animateRows: true,
                    defaultColDef: {
                        sortable: true,
                        resizable: true
                    },
                    floatingFilter: true,
                    suppressMultiSort: true,
                    domLayout: 'autoHeight',
                    rowGroupPanelShow: 'always',
                    rowSelection: 'multiple',
                    // @ts-expect-error ts-migrate(1117) FIXME: An object literal cannot have multiple properties ... Remove this comment to see the full error message
                    rowGroupPanelShow: 'never',
                    rowMultiSelectWithClick: true,
                    pagination: true,
                    paginationPageSize: 15,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        refreshGrid();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                }

                function refreshGrid() {
                    $ctrl.dataLoading = forecastGridService.getForecastProductCodes($ctrl.resolve.changes)
                        .then((items: $TSFixMe) => $ctrl.gridApi.setRowData(items));
                }

                $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

                $ctrl.ok = function () {
                    
                    const changes = _.map($ctrl.gridApi.getSelectedRows(), (data: $TSFixMe) => {
                        return {
                            forecastId: data.forecastId,
                            oldProductCode: data.oldProductCode,
                            newProductCode: data.newProductCode
                        }
                    });
                    $ctrl.dataLoading = forecastProcessService.changeProductCodes(changes).then(() => {
                        $ctrl.close({ $value: true });
                    })
                };

                $ctrl.cancel = function () {
                    $ctrl.dismiss({ $value: 'cancel' });
                };
            }]
    })

})(angular.module('topline.modules'));